<template>
	<div>
		<el-dialog title="修改视频" width="1100px" class="icon-dialog" :visible.sync="show" @open="open"
			:before-close="closeForm" append-to-body>
			<el-form :size="size" ref="form" :model="form" :inline="true">
				<el-form-item label="科目类别：">
					<el-select style="width: 100px;" size="small" v-model="form.subject" placeholder="请选择">
						<el-option v-for="type in subject" :label="type.key" :value="type.value"
							:key="type.value"></el-option>
					</el-select>
				</el-form-item>
				<el-row>
					<div>
						<div style="margin-bottom: 10px;">设置视频图文讲解</div>
						<quill-editor ref="text" v-model="form.content" class="editor" :options="editorOption" />
					</div>
				</el-row>
				<el-row>
					<div class="flexs-l">
						<div>上传视频封面图片</div>
						<div>
							<el-upload class="avatar-uploader" :action="updatehttp"
								accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP" :headers="headers"
								:show-file-list="false" :on-success="handleAvatarSuccess"
								:before-upload="beforeAvatarUpload">
								<el-image v-if="form.icon" class="avatar" :src="form.icon"></el-image>
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</div>
					</div>
				</el-row>

			</el-form>
			<el-form :size="size" ref="form" :model="form" :rules="rules"
				:label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
				<el-row>
					<el-col :span="24">
						<el-form-item label="文章标题" prop="title">
							<el-input v-model="form.title" autoComplete="off" clearable placeholder="请输入文章标题"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="简短描述" prop="describe">
							<el-input v-model="form.describe" autoComplete="off" clearable placeholder="请输入简短描述"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="作者" prop="author">
							<el-input v-model="form.author" placeholder="请输入作者"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="来源" prop="from">
							<el-input v-model="form.from" clearable placeholder="请输入内容来源"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getartedit } from '../../api/userMG';
import '../../assets/css/quillEditor.css';
//引入Qill插件
import Quill from "quill";

// 自定义字体
let fontFamily = ['宋体', '黑体', '微软雅黑', '楷体', '仿宋', 'Arial', '苹方'];
Quill.imports['attributors/style/font'].whitelist = fontFamily;
Quill.register(Quill.imports['attributors/style/font']);

// 自定义文字大小
let fontSize = ['10px', '12px', '14px', '16px', '20px', '24px', '36px']
Quill.imports['attributors/style/size'].whitelist = fontSize;
Quill.register(Quill.imports['attributors/style/size']);

// 新增行高
let Parchment = Quill.import("parchment");
let lingHeight = ['initial', '1', '1.5', '1.75', '2', '3', '4'];
class lineHeightAttributor extends Parchment.Attributor.Style { }
const lineHeightStyle = new lineHeightAttributor("lineHeight", "line-height", {
	scope: Parchment.Scope.INLINE,
	whitelist: lingHeight
});
Quill.register({ "formats/lineHeight": lineHeightStyle }, true);

// 对齐方式样式都改成style方式，而不是class
let Align = Quill.import('attributors/style/align');
Align.whitelist = ['right', 'center', 'justify'];
Quill.register(Align, true);

const toolbarOptions = [
	[
		"bold",
		"italic",
		"underline",
		"strike",
		"blockquote",
		"code-block",
		{ header: 1 },
		{ header: 2 },
		{ list: "ordered" },
		{ list: "bullet" },
		{ indent: "-1" },
		{ indent: "+1" },
		{ script: "sub" }, // 下标
		{ script: "super" }, // 上标
		{ align: [] },
		{ color: [] },
		{ background: [] },
		"link",
		"image",
	],
	[{ size: fontSize }], // 文字大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
	[{ font: fontFamily }], // 字体
	[{ lineheight: lingHeight }]   // 行高
];
export default {
	name: 'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
		info: {
			type: Object,
		}
	},
	data() {
		return {
			updatehttp: '/problem/getImg',
			headers: {
				token: localStorage.getItem('logintoken')
			},
			subject: [
				{ key: '请选择', value: '' },
				{ key: '科目一', value: 0 },
				{ key: '科目二', value: 1 },
				{ key: '科目四', value: 3 },
			],
			form: {
				aid: '',
				subject: '',
				title: '',
				content: '',
				describe: '',
				author: '',
				from: '',
				degfree: '',
				icon: ''
			},
			editorOption: {
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							lineheight: function (value) {
								if (value) {
									this.quill.format('lineHeight', value);
								} else {
									console.log(value);
								}
							},
						},
					}
				},
			},
			classify: [],
			role_ids: [],
			loading: false,
			lists: [],
			pcidlist: [],
			rules: {
			}
		}
	},
	methods: {
		handleAvatarSuccess(res, file) {
			console.log(res, '成功失败');
			this.form.icon = res.img_url
		},
		handleAvatarSuccess1(res, file) {
			console.log(res, '成功失败');
			this.form.video = res.img_url
		},
		beforeAvatarUpload(file) {
			// const isJPG = file.type === 'image/jpeg';
			// const isLt2M = file.size / 1024 / 1024 < 2;

			// if (!isJPG) {
			// this.$message.error('上传头像图片只能是 JPG 格式!');
			// }
			// if (!isLt2M) {
			// this.$message.error('上传头像图片大小不能超过 2MB!');
			// }
			// return isJPG && isLt2M;
		},
		open() {
			this.form = this.info
			console.log(this.form, '=========');
			this.form.echo = 'set'
		},
		submit() {
			console.log(this.form);
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					getartedit(this.form).then(res => {
						console.log(res.code);
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						// this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			this.form = {
				aid: '',
				subject: '',
				title: '',
				content: '',
				describe: '',
				author: '',
				from: '',
				degfree: '',
				icon: ''
			}
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped >

.videos {
	margin-top: 10px;
	width: 160px;
	height: 160px;
}

.avatar-uploader .el-upload {
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 160px;
	height: 160px;
	line-height: 160px;
	text-align: center;
	border: 1px solid #dadcdf;
	margin-top: 10px;
	border-radius: 10px;
}

.avatar {
	margin-top: 10px;
	width: 160px;
	height: 160px;
	display: block;
	border: 1px solid #dadcdf;
}
</style>



// WEBPACK FOOTER //
// src/views/secret/update.vue